// extracted by mini-css-extract-plugin
export default {"button":"Button_button__GRKg7","zero":"Button_zero__X6GOH","orange-background":"Button_orange-background__yazFJ","gray-background":"Button_gray-background__fA3nO"};